// 暫定的に休診日リストをハードコードしてある
// フォーマット
// - カンマ区切りの日付列 '2024-08-01,2024-08-20'
// - 午前/午後のみ休診の場合はampmをつける '2024-08-02am, 2024-08-03pm'
const ALL_CLOSED_DAYS: { [key: string]: string } = {
  '7d8d34d9-a5d9-4f76-b77b-9663ccf67935': '2024-08-24', // 八木内科医院
  '68312931-6c3f-45dc-a673-d0794e7c4901': '2024-08-23', // 医療法人社団 水野内科クリニック
  '28d57df2-75fb-48d4-be50-5424dcce26f2': '2024-08-19', // きたじま内科・脳神経クリニック
  '49f18a63-5634-4261-bcad-21187e38bcd6': '2024-08-08,2024-08-09,2024-08-10', // 医療法人緑和会 加地内科クリニック
  '6eb70128-8c50-42fb-95d2-76197094c939': '2024-08-09,2024-08-10', // 医療法人あさい内科 鶴橋なんばクリニック
  'd205381d-543a-4e70-8fbe-45e62488625e': '2024-08-10', // 医療法人社団 山口内科整形外科
  'bbc61227-979d-4e24-9c30-bd6ab181edb2': '2024-08-22,2024-08-23,2024-08-24,2024-08-25', // 医療法人健仁会 健仁整形外科・内科
  'f3e2c102-a39d-44cd-bcaa-99cac013a88e': '2024-08-10,2024-08-30,2024-08-31,2024-09-01', // 医療法人社団千晶会 落合駅前クリニック
  '83080a59-78c8-485b-b200-749d316be756': '2024-08-31pm', // Haruクリニック
  '12ff0798-a2c9-4ee2-923b-199aae928da8': '2024-08-10', // なら家庭医療クリニック
  'f74f91b6-f26f-4797-967e-028a31ff448f': '2024-08-20,2024-08-21', // 藤クリニック
  'ac5dc19f-f8c4-482a-8b1b-71d8043fb518': '2024-08-06,2024-08-07,2024-08-08', // 駒沢メンタルクリニック
  '00143688-a4fb-4c21-90ad-f167db1ee87a': '2024-08-10', // 医療法人紫陽 クリニックサンセール
  '9021b1d4-924a-4382-88b1-3fa99a4657a9': '2024-08-10', // 医療法人健緑会 田ノ口診療所
  '364d6b68-3cb8-496b-ac19-59e7509f2534': '2024-08-10', // 医療法人社団アズロード 高輪台整形外科クリニック
  '5a90df2d-2009-47d3-91ff-51efddaa6006':
    '2024-08-03,2024-08-07,2024-08-10,2024-09-07,2024-09-28,2024-10-05,2024-10-10,2024-10-26,2024-11-02', // 奥村クリニック
  '1db7ce50-912c-411f-9db6-3b415409c5e6': '2024-08-19', // 春岡通クリニック
  '17e5457b-f949-4fc0-8753-e4b94c80985b': '2024-08-08,2024-08-09,2024-08-31', // かづのファミリークリニック
  '1846f4c1-f671-4003-bb9b-f32ffcde0668': '2024-08-24', // 医療法人あすなろ会 小林小児科クリニック
  '3648dc8f-bcd0-4519-82d8-b5195f4a2cc4': '2024-08-26,2024-08-27', // 医療法人文英会 土岐医院
  'acbf0aed-3359-46d5-b764-3b2c5f750d4d': '2024-08-01,2024-08-02,2024-08-03,2024-08-04,2024-08-05,2024-08-06', // 医療法人社団博医会 船堀内科クリニック
  '0d754d5f-b769-4d8b-8a57-433be3e123d3': '2024-08-10', // 綱川眼科診療所
  '71d965f1-8da3-4970-8c4e-201878c9a6b5': '2024-08-20,2024-08-21', // 医療法人社団RIC RICメンタルクリニックあざみ野
  '904d4f94-f7a5-49fb-8665-414f380c1a80': '2024-08-19,2024-08-20,2024-08-21,2024-08-22', // かしま内科・循環器内科クリニック
  '968724f8-27f2-4b2e-9210-8fadc72c59fe': '2024-08-10', // 医療法人美登会 はるみクリニック
  'a40338f6-9e03-415c-916c-ec02458e2e07': '2024-09-03pm,2024-09-10pm', // さいわい内科消化器クリニック
  'bdf1c449-a371-4f5e-a4ba-0c33dbe32067': '2024-08-06', // 医療法人 市川医院
  '589b3d04-273a-4b66-9028-3628deb547af':
    '2024-08-04,2024-08-05,2024-08-06,2024-08-07,2024-08-08,2024-08-08,2024-08-09,2024-08-10', // 町のクリニック目白
  'd647357e-0618-4b59-999c-7ed50cc1dd92':
    '2024-08-19,2024-08-20,2024-08-21,2024-08-22,2024-08-23,2024-08-24,2024-08-25', // 渋谷済生クリニック
  '93558584-4916-4e5f-ab14-7ea067c3ecc4': '2024-08-10', // 医療法人社団慈成会 武井胃腸科内科
  '3c67ac98-0440-4519-ab70-07a04d3af718': '2024-08-09,2024-08-10', // 温クリニック四万十
  '2b1e4e07-6261-4634-a028-00bdde346c4e':
    '2024-09-19pm,2024-10-17pm,2024-11-21pm,2024-12-19pm,2024-10-18pm,2024-11-11,2024-12-02am,2024-12-27,2024-12-28,2024-12-29,2024-12-30,2024-12-31,2025-01-01,2025-01-02,2025-01-03,2025-01-04,2025-01-05,2025-01-06am,2025-01-16pm,2025-02-12,2025-02-20pm,2025-03-21', // 医療法人社団松慶会 赤坂一ツ木通りクリニック
  'c6fa02c9-7bff-4a82-ac98-3bf8ff5005c5': '2024-08-10', // 鷲宮ファミリークリニック
  '5766e608-2515-42e0-babc-46bfc4e5bc2f': '2024-08-19', // 医療法人 竹広内科
  'a2f37408-da30-4944-9a84-eed21b08989e': '2024-08-06,2024-08-07,2024-08-08,2024-08-09,2024-08-10', // 小林クリニック
  '39e7f7c8-661f-4135-86aa-5b3df0aafa38':
    '2024-09-14,2024-09-15,2024-09-16,2024-09-17,2024-09-18,2024-09-19,2024-09-20', // 医療法人社団慶望会 笠井内科循環器クリニック
  'ec9a5402-e8dd-48f6-967e-eaf8dd1b61ff': '2024-08-19,2024-08-20,2024-08-21', // 松本クリニック
  '558c904d-2b59-45c9-818c-5621ec377ebe':
    '2024-08-26,2024-08-27,2024-08-28,2024-08-29,2024-08-30,2024-08-31,2024-09-01,2024-09-02,2024-09-09,2024-09-30', // 東長崎駅前内科クリニック
  'd088ac04-8a77-4867-9076-3217f82e376b': '2024-09-14', // 西村内科クリニック
  '14e9589d-af47-403f-bcca-f6d52a995b9c': '2024-08-31', // 医療法人社団秀徳会 川村医院
  'adcc2ea2-df86-4933-aa51-77dd59c2de79':
    '2024-09-07pm,2024-09-12,2024-09-14pm,2024-09-19,2024-09-21pm,2024-09-22,2024-09-23,2024-09-24,2024-09-25,2024-09-26,2024-09-27,2024-09-28,2024-09-29,2024-09-30,2024-10-08,2024-10-17,2024-10-31,2024-11-16,2024-11-21,2024-11-23,2024-11-28', // 医療法人社団 けい子レディースクリニック表参道
  'e17f7e40-02d6-4347-98d0-76d58c3cd635': '2024-10-31pm', // 医療法人社団アウル いちかわ内科脳神経内科
  '25cce94a-9fe0-4997-ac23-d4bb3ca68e61': '2024-10-26pm', // 医療法人社団きたがわ内科クリニック 金沢ハートクリニック・きたがわ内科
  '89023642-3525-40d9-94ab-0862cdc82a45': '2024-09-29', // 医療法人 玄一会 なかつか内科医院
  '34e8b6a6-3218-4aab-aba4-4a7868c746dd': '2024-10-23pm', // かめざわ眼科
  '46385e00-1a72-446f-a067-acc8255f67e1': '2024-12-29,2024-12-30,2024-12-31,2025-01-01,2025-01-02,2025-01-03', // 医療法人社団三浦医院
  '72205010-1bd0-4870-a5d6-5b03308bfab6': '2024-12-27', // 医療法人樹心会 たけだクリニック整形外科・内科
  'e0cc50c7-9e2b-4125-b7f6-9db0d5f7f1a2': '2024-12-25', // 北山整形外科・手のクリニック
  '96bd57ea-9dd8-45d2-a6f4-d35d31f52251':
    '2024-12-28,2024-12-29,2024-12-30,2024-12-31,2025-1-1,2025-1-2,2025-1-3,2025-1-4,2025-1-5,2025-1-6,2025-1-7,2025-1-8', // とかち消化器内視鏡クリニック
};

// 年末年始の一括指定対象外の医療機関
// 対象外の医療機関は個別に休診日設定を行う運用となっている。
const DISABLE_END_YEAR_VACATIONS: string[] = [
  '46385e00-1a72-446f-a067-acc8255f67e1', // 医療法人社団三浦医院
  '96bd57ea-9dd8-45d2-a6f4-d35d31f52251', // とかち消化器内視鏡クリニック
];

// リクエスト予約の対象医療機関
// リクエスト予約の場合、「当日は電話」「翌日以降は折り返し電話」による流れになる
const REQUEST_APPOINTMENT_INSTITUTIONS = [
  // 'c5a3edda-8304-4c23-877e-774a5db04dd4', // 集患テストクリニック（QA用）
  // 'c1e6fa5e-b04f-4050-8485-0954e6bad476', // 集患テストクリニック
  // '8ea4c506-c059-48a5-8dc6-9e46fb494202', // 東日本橋内科クリニック
  '78284223-b09a-4ca4-94ef-06ca9f1f99bd', // はるそら内科クリニック
  '1a497384-84f4-4067-ab6b-3daace2e68a1', // 医療法人社団淳厚会 元町レディースクリニック
  'f74f91b6-f26f-4797-967e-028a31ff448f', // 藤クリニック
  '34e8b6a6-3218-4aab-aba4-4a7868c746dd', // かめざわ眼科
  'e4e184ff-b713-4ef2-ab7e-f71eafcbae05', // おおや内科ハートクリニック
  '0f81cb84-3de3-4407-b64c-4588559347df', // 前田ホームクリニック
];

// 予約メニューを設定している医療機関
const RESERVATION_MENU_INSTITUTIONS: { [key: string]: MenuItem[] } = {
  // 東日本橋内科クリニック
  '8ea4c506-c059-48a5-8dc6-9e46fb494202': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 集患テストクリニック（QA用）
  'c5a3edda-8304-4c23-877e-774a5db04dd4': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: '風邪症状のある方（10日以内に、発熱・ノドの痛み・咳・鼻水・倦怠感など一つ以上）は、事前にお電話ください。\n新型コロナとの区別が困難なため時間指定、隔離診察にて対応しています。\n発熱外来の時間は午前10:00~11:30、午後16:00~17:30となります。',
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // さいわい内科消化器クリニック
  'a40338f6-9e03-415c-916c-ec02458e2e07': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団 けい子レディースクリニック表参道
  'adcc2ea2-df86-4933-aa51-77dd59c2de79': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団景星会 大塚北口診療所
  '223f0754-74b9-4671-8976-9554bc9f0588': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // サクラギクリニック
  '0da089bf-c6cc-40a9-93a8-a57897e3c2d0': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人陶菁会 陶山医院
  'caa7c63f-8dc1-4750-8d61-f87bf6eadc8b': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人しょう恵会 木村内科
  '345e2c90-fa16-41e2-b0d1-a080cebc54cd': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // まにわクリニック
  '21070488-c2a8-4151-ad10-27b9b8d71049': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団東京ハート会 一之江ハートクリニック
  '5450a395-b120-45d5-9a20-161cb0207b8f': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人健仁会 健仁整形外科・内科
  'bbc61227-979d-4e24-9c30-bd6ab181edb2': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団東京ハート会 一之江ハートクリニック
  '5eaa8ce3-a945-43cf-bb90-46461c119338': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // さつき町診療所
  'c60bef8c-b1e6-4c5f-9a8a-73af4298f875': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人緑和会 加地内科クリニック
  '49f18a63-5634-4261-bcad-21187e38bcd6': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 共幸会 よしかわ健やかクリニック
  '9e7a3edc-55cf-40bb-b7f0-404fb5bdcec7': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団 康和会 高須町塚診療所
  '3271f4b7-4a2f-447d-9525-f7aae9801cb2': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 岡原クリニック
  '564eafc3-6581-4240-a5ed-61e0dd2a471d': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 池田クリニック
  'dc5de9b9-00f5-4d03-b305-da9cb2fe3545': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 那賀町国民健康保険 木頭診療所
  'd29d8156-0d9a-43e8-aa3b-ff8c73f67580': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 奄美市住用国民健康保険診療所
  '9f2a18b3-996f-4519-a62c-5791192765a4': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // みずの内科・外科クリニック
  '0712cb8b-9d63-4e3f-abad-8d71e9e63f8f': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 土田内科医院
  'aa3fe9fb-422f-49b1-a5cc-16df1e8d4496': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 田沼脳神経クリニック
  '5975e7ea-83fc-4cd6-9a86-7bc62bed19ff': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 橘医院
  '528e983c-516f-4b89-863b-c9e09c6cf900': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団仁誠会 徳永医院
  '4a2e09a7-0b2d-4639-bda3-2015add854b5': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人社団 田熊巻幡医院 まきはたクリニック
  '4ea8392d-cf2e-407f-a181-5c2cd869a550': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // あかばね腎・泌尿器クリニック
  'ca4519fc-e2ee-4021-8b2d-c7822873540d': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人仁医会 井口医院
  'fad90f33-67d3-401c-9ffb-4da008b456a3': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 森下整形外科医院
  '7ed61f96-2c63-490f-b56d-49483e8b517e': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 樹心会 たけだクリニック整形外科・内科
  '72205010-1bd0-4870-a5d6-5b03308bfab6': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 川下ばく内科
  '77402675-74e0-492d-abe1-8035720e2005': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 赤羽医院
  'f46597e5-b792-460f-b76b-e0bd1f470a63': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人紫陽 クリニックサンセール
  '00143688-a4fb-4c21-90ad-f167db1ee87a': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人明日香会 あだち医院
  'ec6e3337-13e0-44bf-9ada-bc396ac6381f': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 藤クリニック
  'f74f91b6-f26f-4797-967e-028a31ff448f': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 小林内科・循環器クリニック
  'd1c20934-1758-4bfa-8278-e494e9c733b1': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 豊田内科
  '85f51357-c615-4d4a-a446-d15641ab9bb0': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 今帰仁診療所
  'b64d509f-fa93-4343-b94b-d11f2aef93a2': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 源流会 橋野医院
  'f974ab54-4a06-4a27-96e9-8ac5826df0c9': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // とかち消化器内視鏡クリニック
  '96bd57ea-9dd8-45d2-a6f4-d35d31f52251': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 温クリニック四万十
  '3c67ac98-0440-4519-ab70-07a04d3af718': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 博恵会 町田整形外科
  '1a64fe2c-15d6-4cc3-b95a-3cbd9e28ebe6': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 医療法人 玄一会 なかつか内科医院
  '89023642-3525-40d9-94ab-0862cdc82a45': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
  // 陽和クリニック
  '12bddda5-f6f1-4f33-a333-33893baec0f5': [
    {
      name: '発熱もしくは風邪症状（せき・のどの痛み・鼻水など）がある方',
      flow: 'telephone',
      note: null,
    },
    { name: 'それ以外の方', flow: 'web', note: null },
  ],
};

type MedicalInstitutionReservationPreference = {
  medicalInstitutionId: string;
  type: 'preRegistration' | 'requestAppointment';
  closedDays: string | null;
  disabledEndYearVacation2024: boolean; // 2024年末年始の一括指定対象外の医療機関
  menus: MenuItem[];
};

type MenuItem = {
  name: string;
  flow: 'web' | 'telephone';
  note: string | null;
};

// ハードコードで対応しているGPごとの設定情報
// - 予約タイプ: 事前登録 or リクエスト予約
// - 休診日: カンマ区切りの日付列 '2024-08-01,2024-08-20'
// - 予約メニュー: 任意のメニュー名を持つ入口。メニューごとに予約フロー(Web or 電話)を設定できる
export function getMedicalInstitutionAppointmentPreference(
  medicalInstitutionId: string,
): MedicalInstitutionReservationPreference {
  const pref: MedicalInstitutionReservationPreference = {
    medicalInstitutionId,
    type: 'preRegistration',
    closedDays: null,
    disabledEndYearVacation2024: false,
    // メニューが1件の場合、表示はされずそれがデフォルトで選択されることになる。なのでメニュー名は適当にしている。
    menus: [{ name: '__DEFAULT__', flow: 'web', note: null }],
  };

  if (REQUEST_APPOINTMENT_INSTITUTIONS.includes(medicalInstitutionId)) {
    pref.type = 'requestAppointment';
  }

  if (ALL_CLOSED_DAYS[medicalInstitutionId] != null) {
    pref.closedDays = ALL_CLOSED_DAYS[medicalInstitutionId];
  }

  if (DISABLE_END_YEAR_VACATIONS.includes(medicalInstitutionId)) {
    pref.disabledEndYearVacation2024 = true;
  }

  if (RESERVATION_MENU_INSTITUTIONS[medicalInstitutionId] != null) {
    pref.menus = RESERVATION_MENU_INSTITUTIONS[medicalInstitutionId];
  }

  return pref;
}
